<template>

  <div>
    <transition-group
      name="slide-fade"
      tag="ul"
      class="warns adapted-meet-right-10">
      <li
        v-for="warn in warns"
        :key="warn.id"
        class="alert"
        :class="`alert-${warn.status}`">
        <h4 class="title">{{ warn.title }}</h4>
        <p class="message">{{ warn.message }}</p>
      </li>
    </transition-group>
  </div>

</template>

<script>
export default {
  name: 'Warn',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    warns () {
      /* return [{
        title: 'Titulo curto',
        message: 'mensagem longa',
        status: 'success'
      }] */
      return this.$store.getters.getWarns
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul.warns{
  list-style: none;
  padding: 0;
  margin: 0;
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 100%;
  max-width: 220px;
}
  ul.warns > li {
    padding: 1em 1.5em;
    margin: 5px;
    border-radius: 5px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
  }
  ul.warns > li > h4{
    font-size: 1em;
    font-weight: bold;
    margin: 0 0 0.3em 0;
  }
  ul.warns > li > p.message{
    padding: 0;
    margin: 0;
  }

/* Animações de entrada e saída podem utilizar diferentes  */
/* funções de duração e de tempo.                          */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Warn/Warn.vue